import type { RouteRecordRaw } from 'vue-router';

export const giftCardRoutes = {
  name: 'gift-card',
  path: 'gift-card',
  component: () => import('./GiftCard.vue'),
} satisfies RouteRecordRaw;
